import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function initiativeSid() {
  let sid = sessionStorage.getItem("ini_sid");
  if (!sid) { sid = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem("ini_sid", sid); }
  return sid;
}

// Traccia visite/aperture/condivisioni di un'iniziativa (fire-and-forget)
export function trackInitiative(slug, event, src) {
  if (!slug) return;
  axios.post(`${API}/public/initiatives/${slug}/track`, { event, src: src || undefined, sid: initiativeSid() }).catch(() => {});
}
